import { CarEBoxLocations } from '../types';

import { locatorServiceAPI } from 'shared/services';

export const carsAPI = {
  getCarEBoxLocations: () => locatorServiceAPI.get<CarEBoxLocations>('navigation/autosCoordinates')
}
